module.exports = __webpack_public_path__ + "images/store_case_study/sbkart-pic2_cf71e3febbc1202014b02e8aabf37492.png";